import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=3cd94434&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardCard.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=3cd94434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd94434",
  null
  
)

component.options.__file = "DashboardCard.vue"
export default component.exports